module.exports = "<div class=\"programming-event\">\n\t<div class=\"content\">\n\t\t<div class=\"trigger\">\n\t\t\t<h4>When this happens...</h4>\n\t\t\t<div class=\"well\">\n\t\t\t\t{{(event | async)?.event?.display}}\n\t\t\t</div>\n\t\t</div>\n\t\t<div class=\"actions\">\n\t\t\t<div class=\"codeitems\">\n\t\t\t\t<router-outlet></router-outlet>\n\t\t\t</div>\n\t\t</div>\n\t</div>\n</div>\n"


//////////////////
// WEBPACK FOOTER
// ./~/@c4/programming/src/app/advanced/event/event.component.html
// module id = 1514
// module chunks = 2